import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.overlay = null
  }

  disconnect() {
    this.close()
  }

  open(event) {
    const img = event.currentTarget
    const src = img.dataset.lightboxSrc || img.src

    this.overlay = document.createElement("div")
    Object.assign(this.overlay.style, {
      position: "fixed",
      inset: "0",
      zIndex: "9999",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(0, 0, 0, 0.85)",
      cursor: "pointer",
    })
    this.overlay.addEventListener("click", () => this.close())

    const closeBtn = document.createElement("button")
    Object.assign(closeBtn.style, {
      position: "absolute",
      top: "1rem",
      right: "1rem",
      color: "white",
      fontSize: "2rem",
      background: "none",
      border: "none",
      cursor: "pointer",
      lineHeight: "1",
    })
    closeBtn.textContent = "×"
    closeBtn.addEventListener("click", () => this.close())

    const fullImg = document.createElement("img")
    fullImg.src = src
    Object.assign(fullImg.style, {
      maxWidth: "90vw",
      maxHeight: "90vh",
      objectFit: "contain",
      borderRadius: "0.75rem",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    })
    fullImg.addEventListener("click", (e) => e.stopPropagation())

    this.overlay.appendChild(closeBtn)
    this.overlay.appendChild(fullImg)
    document.body.appendChild(this.overlay)
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    if (this.overlay) {
      this.overlay.remove()
      this.overlay = null
      document.removeEventListener("keydown", this.handleKeydown)
    }
  }

  handleKeydown = (event) => {
    if (event.key === "Escape") this.close()
  }
}
